import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { type CreateInquiryRequest, createInquiry } from '@/lib/apiClients/inquiry'
import { queryKeys } from '@/lib/queryKeys'

export function useCreateInquiry() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateInquiryRequest) => {
      return createInquiry(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiries.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assignMembers.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.salesforceDeals() })
      queryClient.invalidateQueries({ queryKey: queryKeys.salesforceDealAnos() })
      toast.success('引合を作成しました')
    },
    onError: (error: Error) => {
      toast.error(`引合の作成に失敗しました: ${error.message}`)
    },
  })
}
